import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/covers/laugh-cover-phone.jpg")